export interface LotParams {
  dataCriacao: string | null
  descricao: string | null
  id: string | null
  idFazenda: string | null
  idLote?: string | null
  regime: string | null
}

export class Lot {
  dataCriacao: string | null
  id: string | null
  idFazenda: string | null
  idLote?: string | null | undefined
  regime: string | null
  descricao: string | null
  constructor({
    dataCriacao = new Date().toISOString(),
    descricao = null,
    id = null,
    idFazenda,
    idLote = null,
    regime = null
  }: LotParams) {
    this.dataCriacao = dataCriacao
    this.id = id
    this.idFazenda = idFazenda
    this.idLote = idLote
    this.regime = regime
    this.descricao = descricao
  }
}
